module.exports = __webpack_public_path__ + "resources/img/img_logo_pulsar_pc_kr.c0c84b48368e616437da394931ef018c.png";